import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import FiltersContainer from './../../containers/Filters/Filters.containers';

const FiltersPanel = (props) =>
        <div className='applied-filters notranslate'>
            <div className='applied-filters__heading'>
                <FormattedMessage id='General_CoreFunctionality_UIText_general.filters' />:
            </div>
            <FiltersContainer readOnly urlParams={props.urlParams}/>
        </div>;

export default FiltersPanel;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Filters/FiltersPanel.jsx